(() => {
  const selector = '[data-kp-subscription-minimum]';

  const minimumFor = (input) => Number.parseInt(input.dataset.kpSubscriptionMinimum || '2', 10);

  document.addEventListener('click', (event) => {
    const decrease = event.target.closest('[data-decrease-quantity]');
    const input = decrease?.closest('[data-quantity-selector]')?.querySelector(selector);
    if (!input) return;

    const quantity = Number.parseInt(input.value || '0', 10);
    const minimum = minimumFor(input);
    if (quantity > minimum) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = String(minimum);
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.(selector);
    if (!input) return;

    const quantity = Number.parseInt(input.value || '0', 10);
    const minimum = minimumFor(input);
    if (quantity !== 0 && quantity < minimum) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = String(minimum);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const line = Number.parseInt(input.dataset.kpCartLine || '0', 10);
    const row = input.closest('[data-cart-item]');
    const tiers = [...(row?.querySelectorAll('[data-kp-cart-tier]') || [])]
      .map((tier) => ({
        threshold: Number.parseInt(tier.dataset.kpThreshold || '0', 10),
        planId: tier.dataset.kpPlanId,
      }))
      .filter((tier) => tier.threshold > 0 && tier.planId)
      .sort((left, right) => left.threshold - right.threshold);

    if (!line || quantity < minimum || !tiers.length) return;

    let activeTier = tiers[0];
    tiers.forEach((tier) => {
      if (quantity >= tier.threshold) activeTier = tier;
    });

    if (activeTier.planId === input.dataset.kpCurrentSellingPlan) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const root = window.Shopify?.routes?.root || '/';
    window.fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        line,
        quantity,
        selling_plan: Number(activeTier.planId),
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Could not update subscription tier');
        return response.json();
      })
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart },
          bubbles: true,
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(() => {
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }, true);
})();
